import * as React from "react";
const SvgView3D20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M3.81 10.287c.262-.116.58-.188.9-.188.957 0 1.972.537 1.972 1.813 0 .986-.725 1.812-2.045 1.812-1.174 0-2.088-.826-2.146-2.103l-1.696.363c.116 1.697 1.493 3.233 3.857 3.233 2.421 0 3.784-1.566 3.784-3.306 0-2.044-1.595-3.103-3.117-3.132l2.856-2.566V4.719H1.128v1.552h4.785L2.984 8.924l.827 1.364Zm8.385 3.118v-7.09h1.841c1.784 0 3.249 1.16 3.249 3.566 0 2.378-1.48 3.524-3.263 3.524h-1.827ZM14.08 15c2.784 0 5.017-1.827 5.017-5.119 0-3.306-2.204-5.162-5.003-5.162h-3.639V15h3.625Z"
    })
  );
export default SvgView3D20Px;
